var session_loyaltyMemberWidgetConfig = "LoyaltyMemberWidgetConfig";
var session_loyaltyProgramTag = "LoyaltyProgramTag";
var session_loyaltyInvite = "page";

const originalConsoleLog = console.log;
console.log = function (...args) {
   if (window.DebugMode) {
      originalConsoleLog.apply(console, args);
   }
};
const originalConsoleError = console.error;
console.error = function (...args) {
   originalConsoleError.apply(console, args);
   for (const arg of args) {
      if (arg instanceof Error || arg instanceof FetchError || (arg && arg.message && arg.stack)) {
         sendErrorToServer({
            message: `LOYCO: ${arg.message}`,
            source: "console.error",
            stack: arg.stack,
         });
         break;
      }
   }
};

function bypassBlockingFetchWithTimeout(url, timeoutMs) {
   return new Promise((resolve, reject) => {
      const controller = new AbortController();
      let timeoutId;
      timeoutId = setTimeout(() => {
         controller.abort();
         reject(new TimeoutError("Timeout exceeded for request to " + url));
      }, timeoutMs);
      fetch(url, { signal: controller.signal })
         .then(async (response) => {
            clearTimeout(timeoutId);
            if (!response.ok) {
               const errorText = await response.text();
               let errorData;
               try {
                  errorData = JSON.parse(errorText);
               } catch {
                  errorData = errorText;
               }
               const errorDataString = JSON.stringify(errorData);
               const errorMessage = `Fetch failed for request to ${url} with status ${response.status}: ${errorDataString}`;
               throw new FetchError(errorMessage, response.status, errorData);
            }
            try {
               const data = await response.json();
               resolve(data);
            } catch (jsonError) {
               console.error("Failed to parse JSON response. Resolving with Response object.", jsonError);
               resolve(response);
            }
         })
         .catch((error) => {
            clearTimeout(timeoutId);
            reject(error);
         });
   });
}

class TimeoutError extends Error {
   constructor(message) {
      super(message);
      this.name = "TimeoutError";
   }
}

class FetchError extends Error {
   constructor(message, status, data) {
      super(message);
      this.name = "FetchError";
      this.status = status;
      this.data = data;
   }
}

async function getMemberConfig(_addContainer, _applySetting, _manifestBuilder) {
   try {
      const sessionLoyaltyProgramTag = sessionStorage.getItem(session_loyaltyProgramTag);
      if (!sessionLoyaltyProgramTag) applyProgramTag();

      const sessionLoyaltyInvite = sessionStorage.getItem(session_loyaltyInvite);
      if (!sessionLoyaltyInvite) applyInvite();

      const sessionMemberWidgetConfig = sessionStorage.getItem(session_loyaltyMemberWidgetConfig);
      if (sessionMemberWidgetConfig) {
         const json = JSON.parse(sessionMemberWidgetConfig);
         _addContainer && addContainer(json.program.code, "FixedRight");
         _applySetting && applySetting(json);
         _manifestBuilder && manifestBuilder(json.texts.pageTitle, json.resources.faviconUrl);
         console.log("Configuration fetched from session", json);
         return json;
      }

      let domain = location.host;
      let terminal = location.search;
      let terminalGUID = "";
      const baseUrl = "https://memberapi.loyalty.loyall.no";
      if (terminal && terminal !== undefined && terminal !== null && terminal.length == 39) terminalGUID = "/" + terminal;

      const api = `${baseUrl}/api/widget/v1/member/config/${encodeURIComponent(domain + terminalGUID)}`;
      const obj = await bypassBlockingFetchWithTimeout(api, 3000);

      const json = JSON.stringify(obj.data);
      sessionStorage.setItem(session_loyaltyMemberWidgetConfig, json);
      _addContainer && addContainer(obj.data.program.code, "FixedRight");
      _applySetting && applySetting(obj.data);
      _manifestBuilder && manifestBuilder(obj.data.texts.pageTitle, obj.data.resources.faviconUrl);
      console.log("Configuration fetched from api", obj.data);
      return obj.data;
   } catch (error) {
      console.error(error);
   }
}

function applyProgramTag() {
   const tag = new URLSearchParams(window.location.search).get("tag");
   if (tag) {
      sessionStorage.setItem(session_loyaltyProgramTag, tag);
      var newURL = new URL(window.location.origin + window.location.pathname).href;
      window.history.pushState(null, document.title, newURL);
   }
}

function applySetting(obj) {
   // Favicon
   if (obj && obj.resources.faviconUrl) {
      let link = document.querySelector("link[rel~='icon']");
      let appleLink = document.querySelector("link[rel~='apple-touch-icon']");
      if (!link) {
         link = document.createElement("link");
         link.rel = "icon";
         document.getElementsByTagName("head")[0].appendChild(link);
      }
      if (!appleLink) {
         appleLink = document.createElement("link");
         link.rel = "apple-touch-icon";
         document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href = obj.resources.faviconUrl;
      appleLink.href = obj.resources.faviconUrl;
   }
   // mwc -
   if (obj && obj.features.setting) mwc = JSON.parse(obj.features.setting);
   console.log("MWC Initiated", mwc);
}

function addContainer(id, className) {
   if (!document.getElementById(id)) {
      const html = `<div id=${id} class=${className}></div>`;
      document.body.insertAdjacentHTML("afterbegin", html);
      console.log(`Container {${id}} created.`);
   }
}

function logoEnabler(src) {
   const html = `<img id='visbooklogo' src=${src} alt='logo' style='margin-top: 10px; width: auto\\9; /* ie8 */' />`;
   const loyaltyLogo = document.querySelector("#loyaltyLogo");
   if (!src) {
      loyaltyLogo.remove();
      return;
   }
   if (loyaltyLogo) {
      loyaltyLogo.insertAdjacentHTML("afterbegin", html);
      return;
   }
}

function applyInvite() {
   const invite = new URLSearchParams(window.location.search).get("page");
   if (invite) sessionStorage.setItem(session_loyaltyInvite, invite);
}

function manifestBuilder(name, fav) {
   var myDynamicManifest = {
      short_name: name,
      name: `${name} By Loyall ©`,
      Description: "https://www.loyall.io/",
      icons: [
         {
            src: fav ?? "favicon.ico",
            sizes: "32x32 any",
            type: "image/x-icon",
         },
      ],
      display: "standalone",
      theme_color: "#000000",
      background_color: "#ffffff",
   };
   const stringManifest = JSON.stringify(myDynamicManifest);
   const blob = new Blob([stringManifest], { type: "application/json" });
   const manifestURL = URL.createObjectURL(blob);
   const manifest = document.querySelector("#loyaltyManifest");
   if (manifest) manifest.setAttribute("href", manifestURL);
}
